export enum PubNubStatusCategory {
  PNNetworkDownCategory = 'PNNetworkDownCategory',
  PNNetworkIssuesCategory = 'PNNetworkIssuesCategory'
}